import { Component, Input, OnInit } from '@angular/core';
import IGISDataCacheIteratorStatistic = ZoningAPI.IGISDataCacheIteratorStatistic;
import { getPercent, getTime, millisecondsToSeconds } from 'src/app/shared/utils/utils';
import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'app-process-gis-data-cache-iterator-statistic',
    templateUrl: './process-gis-data-cache-iterator-statistic.component.html',
    styleUrls: [
        './process-gis-data-cache-iterator-statistic.component.scss',
        '../../../../../shared/styles/mdl-table.scss'
    ]
})
export class ProcessGisDataCacheIteratorStatisticComponent implements OnInit {
    @Input()
    cacheIteratorStatistic: IGISDataCacheIteratorStatistic;

    millisecondsToSeconds = millisecondsToSeconds;
    getPercent = getPercent;
    getTime = getTime;

    constructor() {}

    ngOnInit(): void {}

    getTotalCachedEntities() {
        if (!this.cacheIteratorStatistic) {
            return 0;
        }
        const stat = this.cacheIteratorStatistic;
        return (
            stat.totalCachedPropertyRecordsCount +
            stat.totalCachedAbuttingPRsCount +
            stat.totalCachedStreetsCount +
            stat.totalCachedPRTagsCount
        );
    }

    getTotalDesiredEntities() {
        if (!this.cacheIteratorStatistic) {
            return 0;
        }
        const stat = this.cacheIteratorStatistic;
        return (
            stat.totalDesiredPRsCount +
            stat.totalDesiredAbuttingPRsCount +
            stat.totalDesiredStreetsCount +
            stat.totalDesiredPRTagsCount
        );
    }

    getTotalRequestedEntities() {
        if (!this.cacheIteratorStatistic) {
            return 0;
        }
        const stat = this.cacheIteratorStatistic;
        return (
            stat.totalRequestedPropertyRecordsCount +
            stat.totalRequestedAbuttingPRsCount +
            stat.totalRequestedStreetsCount +
            stat.totalRequestedPRTagsCount
        );
    }

    getTotalReceivedEntities() {
        if (!this.cacheIteratorStatistic) {
            return 0;
        }
        const stat = this.cacheIteratorStatistic;
        return (
            stat.totalReceivedPropertyRecordsCount +
            stat.totalReceivedAbuttingPRsCount +
            stat.totalReceivedStreetsCount +
            stat.totalReceivedPRTagsCount
        );
    }

    getTotalMissedEntities() {
        if (!this.cacheIteratorStatistic) {
            return 0;
        }
        const stat = this.cacheIteratorStatistic;
        return (
            stat.totalRequestedPropertyRecordsCount -
            stat.totalReceivedPropertyRecordsCount +
            (stat.totalRequestedAbuttingPRsCount - stat.totalReceivedAbuttingPRsCount) +
            (stat.totalRequestedStreetsCount - stat.totalReceivedStreetsCount) +
            (stat.totalRequestedPRTagsCount - stat.totalReceivedPRTagsCount)
        );
    }

    getAVGCacheUsage() {
        if (!this.cacheIteratorStatistic) {
            return 0;
        }
        return getPercent(this.getTotalCachedEntities(), this.getTotalDesiredEntities());
    }

    getAVGRequestedData() {
        if (!this.cacheIteratorStatistic) {
            return 0;
        }
        return getPercent(this.getTotalRequestedEntities(), this.getTotalDesiredEntities());
    }

    getAVGReceivedData() {
        if (!this.cacheIteratorStatistic) {
            return 0;
        }
        return getPercent(this.getTotalReceivedEntities(), this.getTotalRequestedEntities());
    }

    getAVGMissedData() {
        if (!this.cacheIteratorStatistic) {
            return 0;
        }
        return getPercent(this.getTotalMissedEntities(), this.getTotalRequestedEntities());
    }
}
